var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVoiceTel01 = function SvgIconVoiceTel01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_voice_tel-01_svg2__a",
    x1: 37.9,
    x2: 124.74,
    y1: 69.25,
    y2: 58.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_voice_tel-01_svg2__a",
    id: "icon_voice_tel-01_svg2__b",
    x1: 37.74,
    x2: 124.59,
    y1: 67.94,
    y2: 57.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_voice_tel-01_svg2__a",
    id: "icon_voice_tel-01_svg2__c",
    x1: 38.06,
    x2: 124.9,
    y1: 70.57,
    y2: 60.04
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_voice_tel-01_svg2__a",
    id: "icon_voice_tel-01_svg2__d",
    x1: 35.4,
    x2: 122.24,
    y1: 48.65,
    y2: 38.12
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M71.88 84.24c-.75 0-1.5-.29-2.07-.86-1.14-1.14-1.14-3 0-4.14 7.78-7.78 7.78-20.43 0-28.2-1.14-1.14-1.14-3 0-4.14s3-1.14 4.14 0c10.06 10.06 10.06 26.43 0 36.49-.57.57-1.32.86-2.07.86Z",
    style: {
      fill: "url(#icon_voice_tel-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.89 75.2c-.75 0-1.5-.29-2.07-.86-1.14-1.14-1.14-3 0-4.14 2.79-2.79 2.79-7.34 0-10.13-1.14-1.14-1.14-3 0-4.14s3-1.14 4.14 0c5.08 5.08 5.08 13.34 0 18.41-.57.57-1.32.86-2.07.86",
    style: {
      fill: "url(#icon_voice_tel-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.83 92.17c-1.14-1.14-1.14-3 0-4.14 12.62-12.62 12.62-33.16 0-45.78-1.14-1.14-1.14-3 0-4.14s3-1.14 4.14 0c14.91 14.91 14.91 39.16 0 54.07a2.924 2.924 0 0 1-4.14 0Z",
    style: {
      fill: "url(#icon_voice_tel-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78 100a2.933 2.933 0 0 1-2.66-4.14l3.95-8.75a9.59 9.59 0 0 1 8.9-5.64c5.15.09 11.47.19 14.63.12.77-.02 1.8-.17 2.38-.83.57-.64.57-1.6.52-2.12-.38-3.83 1.28-5.94 2.28-7.19.14-.17.29-.37.42-.54l-7.07-4.45a4.86 4.86 0 0 1-2.26-4.62A4.83 4.83 0 0 1 31 57.76l9.89-3.75-1.02-5.36c-.42-2.19.06-4.4 1.36-6.22s3.22-3 5.43-3.32l4.32-.63L40.7 21.02c-2.35-4-3.28-8.72-2.62-13.31l.76-5.21C39.07.9 40.56-.21 42.16.02s2.71 1.72 2.48 3.32l-.76 5.21c-.48 3.27.19 6.65 1.87 9.5l11.04 18.74a4.85 4.85 0 0 1-3.48 7.27l-5.79.85c-.61.09-1.15.42-1.51.92-.36.51-.49 1.12-.38 1.73l1.14 5.97c.44 2.29-.73 4.58-2.83 5.59-.07.03-.15.07-.22.09l-8.8 3.34 5.89 3.7c.09.05.17.11.25.17 1.78 1.39 2.57 3.61 2.03 5.64-.36 1.34-1.1 2.28-1.7 3.03-.79 1-1.19 1.5-1.04 2.97.25 2.54-.44 4.88-1.96 6.59-1.1 1.24-3.14 2.73-6.65 2.8-3.26.06-9.65-.03-14.85-.12-1.48-.03-2.85.83-3.46 2.19l-3.95 8.75a2.94 2.94 0 0 1-2.67 1.72Zm26.28-36.74",
    style: {
      fill: "url(#icon_voice_tel-01_svg2__d)"
    }
  }));
};
export default SvgIconVoiceTel01;